module.exports = __webpack_public_path__ + "static/media/placeholder.e0c82199.svg";